/*
 * File: ClinicalEditButton.tsx
 * Project: mp-mobile-app
 *
 * Created by Cole on 01/02/2020
 *
 * Copyright (c) 2021 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays the edit button for the clinical widgets list view.
 */
import React from "react";
import ClinicalEditDialog, {
  ClinicalEditDialogInner
} from "./ClinicalEditDialog";
import EditIcon from "@material-ui/icons/Edit";
import { withStyles } from "@material-ui/core/styles";
import { IconButton, Theme } from "@material-ui/core";
import { WithStyles } from "@material-ui/styles";

const styles = (theme: Theme) => ({
  editIcon: {
    color: theme.palette.common.icons
  }
});

type Props = WithStyles<typeof styles>;

class ClinicalEditButton extends React.Component<Props> {
  editRef?: ClinicalEditDialogInner | undefined;

  openDialog = () => {
    this.editRef?.setState({
      open: true
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <ClinicalEditDialog
          onRef={ref => {
            this.editRef = ref;
          }}
        />
        <IconButton onClick={this.openDialog}>
          <EditIcon className={classes.editIcon} />
        </IconButton>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(ClinicalEditButton);
